export enum Actions {
	ZoomIn = 'zoom-in',
	ZoomOut = 'zoom-out',
	ToFront = 'to-front',
	Scale = 'scale',
	ToBack = 'to-back',
	Delete = 'delete',
	Undo = 'undo',
	Redo = 'redo',
	OutlineWindowToggle = 'outline-window-toggle',
	ShapePropertiesToggle = 'shape-properties-toggle',
	ShapePropertiesShow = 'shape-properties-show',
	CollectionsToggle = 'collections-toggle',
	WidgetsWizard = 'widgets-wizard-show',
	WidgetsEditCell = 'widgets-edit-cell',
	PreviewToggle = 'preview-toggle',
	SelectContainerSize = 'select-container-size',
	SelectPageSize = 'select-page-size',
	SelectView = 'select-view',
	AssetsWindowToggle = 'assets-window-toggle',
	AssetsGroupsWindowToggle = 'assets-groups-window-toggle',
	FillColorSelect = 'fill-color-select',
	ServiceDesignerElementWindowToggle = 'sd-element-window-toggle',
	ServiceDesignerHistoryWindowToggle = 'sd-history-window-toggle',
	ServiceDesignerLogWindowToggle = 'sd-log-window-toggle',
	ServiceDesignerAutoLayout = 'sd-autolayout',
	ServiceDesignerResetLayout = 'sd-reset-layout',
	ServiceDesignerDraft = 'sd-draft',
	EditDashboardSettings = 'edit-dashboard-properties',
	CustomDataGrid = 'custom-data-grid',
	PageView = 'page-view',
	MasterGridPopup = 'toggle-master-grid-popup',
	SelectDatasourceTypeWindowToggle = 'select-datasource-type-window-toggle',
	TimeSelectorToggle = 'time-selector-toggle',
}
